"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FoldersStyled = require("./Folders-styled.js");
var _FolderItem = _interopRequireDefault(require("../FolderItem"));
var _CreateNewFolder = _interopRequireDefault(require("../CreateNewFolder"));
var _fuse = _interopRequireDefault(require("fuse.js"));
var _actions = _interopRequireDefault(require("../../utils/actions"));
var _calciteComponentsReact = require("@esri/calcite-components-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Folders = function Folders(_ref) {
  var folders = _ref.folders,
    userSession = _ref.userSession,
    createFolderActive = _ref.createFolderActive,
    setCreateFolderActive = _ref.setCreateFolderActive,
    getUserFolders = _ref.getUserFolders,
    selectedFolderId = _ref.selectedFolderId,
    onFolderItemClick = _ref.onFolderItemClick,
    createNewFolder = _ref.createNewFolder,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? true : _ref$label,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? false : _ref$marginBottom,
    queryResults = _ref.queryResults,
    allowCreateNewFolder = _ref.allowCreateNewFolder;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    folderSearchValue = _useState2[0],
    setFolderSearchValue = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modalOpen = _useState4[0],
    setModalOpen = _useState4[1];
  var _useState5 = (0, _react.useState)(""),
    _useState6 = _slicedToArray(_useState5, 2),
    createFolderInputValue = _useState6[0],
    setCreateFolderInputValue = _useState6[1];
  var handleSetFolderSearchValue = function handleSetFolderSearchValue(e) {
    setFolderSearchValue(e.target.value);
  };
  var mFuse = (0, _react.useMemo)(function () {
    var _folders$items = folders.items,
      allIds = _folders$items.allIds,
      byId = _folders$items.byId;
    var folderItems = allIds.map(function (id) {
      return byId[id];
    });
    var options = {
      includeMatches: true,
      keys: ["title"],
      threshold: 0.3
    };
    var fuse = new _fuse.default(folderItems, options);
    return fuse;
  }, [folders.items]);
  var itemsMatchingSearch = (0, _react.useMemo)(function () {
    if (folders) {
      var _folders$items2 = folders.items,
        allIds = _folders$items2.allIds,
        byId = _folders$items2.byId;
      var results = allIds.map(function (id) {
        return byId[id];
      });
      if (folderSearchValue) {
        results = mFuse.search(folderSearchValue).map(function (result) {
          return result.item;
        });
      }
      return results;
    }
    return [];
  }, [folderSearchValue, folders, mFuse]);
  var handleCloseCreateFolder = function handleCloseCreateFolder() {
    setCreateFolderInputValue("");
    setModalOpen(false);
  };
  var handleConfirm = function handleConfirm() {
    _actions.default.createFolder({
      folderName: createFolderInputValue,
      userSession: userSession,
      getUserFolders: getUserFolders,
      queryResults: queryResults
    });
    handleCloseCreateFolder();
  };
  var actionButton = /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
    slot: "primary",
    width: "full",
    onClick: handleConfirm,
    disabled: !createFolderInputValue || undefined
  }, "OK");
  var cancelButton = /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteButton, {
    appearance: "outline",
    onClick: handleCloseCreateFolder,
    slot: "secondary",
    width: "full"
  }, "Cancel");
  return /*#__PURE__*/_react.default.createElement(_FoldersStyled.StyledFoldersWrapper, null, /*#__PURE__*/_react.default.createElement(_FoldersStyled.StyledFolders, {
    selectable: true,
    marginBottom: marginBottom
  }, label && /*#__PURE__*/_react.default.createElement(_FoldersStyled.StyledFoldersHeader, null, typeof label == "string" ? label : "Folders", allowCreateNewFolder && /*#__PURE__*/_react.default.createElement(_FoldersStyled.StyledCalciteTooltipManager, null, /*#__PURE__*/_react.default.createElement(_FoldersStyled.StyledFoldersAddIcon, {
    id: "add-new-folder-icon",
    icon: "folder-plus",
    scale: "s",
    onClick: function onClick() {
      return setModalOpen(true);
    }
  }), /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteTooltip, {
    referenceElement: "add-new-folder-icon",
    placement: "bottom"
  }, "Create new folder"))), /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteModal, {
    active: modalOpen || undefined,
    onCalciteModalClose: function onCalciteModalClose() {
      return setModalOpen(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    slot: "header"
  }, "Create a Folder"), /*#__PURE__*/_react.default.createElement("div", {
    slot: "content"
  }, /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteLabel, null, "Folder Name:", /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteInput, {
    placeholder: "Enter folder name",
    name: "create-folder",
    value: createFolderInputValue,
    onCalciteInputInput: function onCalciteInputInput(e) {
      return setCreateFolderInputValue(e.target.value);
    }
  }))), actionButton, cancelButton), /*#__PURE__*/_react.default.createElement(_FoldersStyled.StyledFoldersSearchWrapper, {
    filterItem: true
  }, /*#__PURE__*/_react.default.createElement(_calciteComponentsReact.CalciteInput, {
    icon: "search",
    placeholder: "Filter folders",
    name: "folder-search",
    value: folderSearchValue,
    onCalciteInputInput: handleSetFolderSearchValue
  })), /*#__PURE__*/_react.default.createElement(_FoldersStyled.StyledFolderItemsWrapper, null, itemsMatchingSearch && itemsMatchingSearch.map(function (_ref2) {
    var id = _ref2.id;
    return /*#__PURE__*/_react.default.createElement(_FolderItem.default, {
      key: id,
      item: folders.items.byId[id],
      selectedFolderId: selectedFolderId,
      onFolderItemClick: onFolderItemClick
    });
  }))), createNewFolder && /*#__PURE__*/_react.default.createElement(_CreateNewFolder.default, {
    createFolderActive: createFolderActive,
    userSession: userSession,
    getUserFolders: getUserFolders,
    setCreateFolderActive: setCreateFolderActive,
    queryResults: queryResults
  }));
};
var _default = Folders;
exports.default = _default;